import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import type { FC } from 'react';
import { meiaRoute } from '../meia.constants';
import { formatDashboardScore } from './meia-p4-run-cases.util';
import type { BriefStudyVerdict } from './meia-p5-brief.util';
import { MeiaPhaseAdvanceBar } from './meia-phase-advance-bar.component';
import { getScoringBandLabel } from './meia-scoring-band.util';

type MeiaP4AdvanceBarProps = {
  studyId: string;
  studyVerdict: BriefStudyVerdict | null;
};

export const MeiaP4AdvanceBar: FC<MeiaP4AdvanceBarProps> = (props) => {
  const { studyId, studyVerdict } = props;

  return (
    <MeiaPhaseAdvanceBar
      backLink={{
        children: (
          <>
            <ArrowLeftIcon className="size-4" /> Back to Phase 3
          </>
        ),
        to: meiaRoute.studyTab({ studyId, tab: 'p3' }),
      }}
      caption="Gate G3 must pass before the brief can be approved at G4"
      forwardLink={{
        children: (
          <>
            Assemble DM Brief <ArrowRightIcon className="size-4" />
          </>
        ),
        to: meiaRoute.studyTab({ studyId, tab: 'p5' }),
      }}
      title={
        <>
          Study verdict:{' '}
          {studyVerdict?.score !== null && studyVerdict?.score !== undefined
            ? `${formatDashboardScore(studyVerdict.score)} · ${getScoringBandLabel(studyVerdict.band)}`
            : 'awaiting scoring output'}
        </>
      }
    />
  );
};
